import { render, staticRenderFns } from "./TramiteSeguimiento.vue?vue&type=template&id=1086390c&"
import script from "./TramiteSeguimiento.vue?vue&type=script&lang=js&"
export * from "./TramiteSeguimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports